<span
  class="absolute -top-1.5 -right-1.5 inline-flex items-center justify-center rounded-full bg-red-900 text-white text-[10px] font-semibold min-w-[18px] h-[18px] px-1">
  {{ count > 99 ? '99+' : count }}
</span>
